import {
  Alert,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useAuditTypes } from "./use-audit-types";

interface AuditTypeSelectorProps {
  value: string;
  onChange: (typeKey: string) => void;
}

const AuditTypeSelector = ({ value, onChange }: AuditTypeSelectorProps) => {
  const { data, error, isLoading } = useAuditTypes();
  const types = data?.results ?? [];

  if (error) {
    return <Alert severity="error">Failed to load audit types.</Alert>;
  }

  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 260 }}>
      <InputLabel id="audit-type-select-label">Audit Type</InputLabel>
      <Select
        labelId="audit-type-select-label"
        label="Audit Type"
        value={value}
        onChange={handleChange}
        disabled={isLoading}
        displayEmpty
      >
        {!isLoading && types.length === 0 && (
          <MenuItem value="" disabled>
            No audit types configured
          </MenuItem>
        )}
        {types.map((type) => (
          <MenuItem key={type.typeKey} value={type.typeKey}>
            {type.displayName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AuditTypeSelector;
